import axios from 'axios'
import {MessageBox, Message, Loading} from 'element-ui'
import {handleError} from './error-info'
import commonJs from "./common";

const axiosInstance = axios.create();//创建axios实例 超时时间
// 注意命名规范，变量名要和网关名称一致
const identityService = process.env.API_ROOT;//接口前缀地址
const manualService = process.env.MANUAL_SERVICE;//文档中心接口前缀地址
const developerService = process.env.DEVELOPER_SERVICE;//文档中心接口前缀地址

const fileService = process.env.FILE_SERVICE;    //图片上传接口前缀
const cloudService = process.env.CLOUD_SERVICE;    //后端图片上传接口前缀
const shopService = process.env.SHOP_SERVICE;    //数据统计
const tenantService = process.env.TENANT_SERVICE;    //数据统计
const functionControlService = process.env.FUNCTION_CONTROLSERVICE;    //功能统计
const pricingProductService = process.env.PRICING_PRODUCT_SERVICE;    //产品服务
const businessPurchaseOrderService = process.env.BUSINESS_PURCHASE_ORDER_SERVICE;    //购买列表
const businessPaymentService = process.env.BUSINESS_PAYMENT_SERVICE;    //支付
const userOperationLogService = process.env.USER_OPERATION_LOG_SERVICE;    //操作日志
const datastatisticsService = process.env.DATASTATISTICS_SERVICE;    //用户统计
const trackingYeeService = process.env.TRACKINGYEE_SERVICE;    //轨迹追踪
const notificationService = process.env.NOTIFICATION_SERVICE;    //消息通知

const geographicService = process.env.COMMON_ROOT;    //国家的信息
const trackingservice = process.env.TRACKING_SERVICE;    //国家的信息
const vatService =  process.env.VAT_SERVICE

let ajaxErrorBool = true;//axios发生错误的请求（401,403,500）
//白名单（3000ms没返回不取消请求）
let whiteList = [
  '/PlatformProductService/AliExpress/SizeTemplate',
  '/PlatformProductService/AliExpress/FreightTemplate',
  '/PlatformProductService/AliExpress/PromiseTemplate',
  '/merchandiseService/merchandiseCategory/categories'
]
//白名单（不加loading效果）
let whiteList1 = [
  '/filterSum',//轮询筛选组单个记录数
  '/merchandises/synchronizationJobGroups',//轮询同步商品进度
  '/merchandises/matchProductSKUJobGroups'// 轮询匹配产品进度
]

// http request 拦截器
axiosInstance.interceptors.request.use(
  config => {   //在请求发出之前进行一些操作
    let blackBool = true;//默认使用loading
    // loading 关闭
    commonJs.finishLoading()
    //白名单不加loading效果
    for(var i = 0;i<whiteList1.length;i++){
      if (config.url.toLocaleLowerCase().indexOf(whiteList1[i].toLocaleLowerCase()) != -1) {
        blackBool = false;
        break
      }
    }
    if(blackBool){
      // loading 开始
      commonJs.beginLoading()
    }
    // localStorage['accessToken'] = "";
    if (!localStorage['accessToken']) {    //没有用户标识  即需要用户去登陆
      this.$http.login() //调用父级方法登录
    } else {
      config.headers['Authorization'] = "Bearer " + localStorage['accessToken'];      //有用户标识 则将用户标识符设置为请求头
    }
    // 白名单免超时
    // whiteList.forEach(t => {
    //   if (config.url.toLocaleLowerCase().indexOf(t.toLocaleLowerCase()) > -1) {
    //     config.timeout = 0
    //   }
    // })
    // if (whiteList.includes(config.url)) {
    //   config.timeout = 0
    // }
    config.startTime = +new Date
    return config
  },
  error => {
    MessageBox.alert(error, '接口请求错误', {
      confirmButtonText: '确定',
    });
    if (!!error) {
      return Promise.reject(error);
    }
  }
)

/**
 * http response 拦截器
 * resp.data.code:
 *    403: 无权限
 *    401：登录无效
 *    200：成功，正常
 */
axiosInstance.interceptors.response.use(
  resp => {     //在这里对返回的数据进行处理
    // loading 关闭
    commonJs.finishLoading()
    resp.config.duration = +new Date - resp.config.startTime
    if(resp.config.duration>=3000){
      //  1.判断请求超时
      if(localStorage['timeoutUrl']){
        let arr = JSON.parse(localStorage['timeoutUrl'])
        arr.push(resp.config.url)
        let timeoutUrl = new Set(arr)
        localStorage['timeoutUrl'] = JSON.stringify(timeoutUrl)
      }else{
        let arr = []
        arr.push(resp.config.url)
        localStorage['timeoutUrl'] = JSON.stringify(arr)
      }
    }
    return Promise.resolve(resp);
  },
  error => {
    error.config.duration = +new Date - error.config.startTime
    // loading 关闭
    commonJs.finishLoading()
    //  1.判断请求超时
    if(error.config.duration>=3000){
      if(localStorage['timeoutUrl']){
        let arr = JSON.parse(localStorage['timeoutUrl'])
        arr.push(error.config.url)
        let timeoutUrl = new Set(arr)
        localStorage['timeoutUrl'] = JSON.stringify(timeoutUrl)
      }else{
        let arr = []
        arr.push(error.config.url)
        localStorage['timeoutUrl'] = JSON.stringify(arr)
      }
    }
    if(ajaxErrorBool){
      if (error.response.status == 403) {
        ajaxErrorBool = false;
        //后台返回登录超时   则置空缓存中的用户标识 并登录
        MessageBox.confirm('您当前没有访问当前页面的权限，请联系管理员', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.login() //调用父级方法登录
        }).catch(() => {
          this.$http.login() //调用父级方法登录
        });

      } else if (error.response.status == 401) {
        ajaxErrorBool = false;
        //后台返回登录超时   则置空缓存中的用户标识 并登录
        MessageBox.confirm('您当前没有访问当前页面的权限，请联系管理员', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.login() //调用父级方法登录
        }).catch(() => {
          this.$http.login() //调用父级方法登录
        });
      }
    }
    if (error.response.status == 500) {
      MessageBox.alert('对不起，系统发生故障！我们正在紧急处理，请稍后再试！错误信息为：'+error.response.data.Errors[0].Message, {
        confirmButtonText: '确定',
        callback: action => {
          // loading 关闭
          commonJs.finishLoading();
        }
      });
      // mutual.toError(error.response.data.Errors[0].Message)
    } else {
      handleError(error.response.data)
    }

    return Promise.reject(error);
  }
);
export default {
  axiosInstance,
  // getFullUrl(url) {
  //   return identityService + url
  // },
  // getShopServiceUrl(url) {
  //   return shopService + url
  // },
  // getMerchandiseServiceUrl(url) {
  //   return merchandiseService + url
  // },
  UploadFiles(url, fileObj,gateway) {     //post请求   上传图片专用
    var data = new FormData();
    if (url.indexOf('http') == -1){
      if(gateway === 'cloudService'){
        url = cloudService + url;
        data.append("associaterType", "contentsService");
        data.append("associaterId", "");
      }else if(gateway === 'businessCharge'){
        url = cloudService + url;
        data.append("associaterType", "businessCharge");
        data.append("associaterId", "");
      }else{
        url = fileService + url;
        data.append("action", "UploadVMKImagePath");
      }
    }
    data.append("file", fileObj); //加入文件对象
    return axiosInstance({
      method: 'post',
      url,
      data,
      cache: false,//上传文件无需缓存
      processData: false,//用于对data参数进行序列化处理 这里必须false
      contentType: false, //必须
      // timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      }
    });
  },
  downFile(method, url, data, gateway) {     //post请求
    if (!gateway) {
      gateway = 'identityService'
    }
    if (url.indexOf('http') == -1) {
      url = eval(gateway) + url;
    }
    // let data1 = method=='get'?'params':'data'
    var obj = {
        method: method,
        url,
        // timeout: 60000,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json; charset=UTF-8',
        }
      },
      params = Object.assign(obj, {responseType: 'blob'});//请求文件流
    if (method=='get') {
      params.params = data
    }else {
      params.data = data
    }
    return axiosInstance(params);
  },

  getImg(url,gateway) {        //get请求图片
    // if (url.indexOf('http') == -1) url = fileService + url;
    if(gateway && gateway === 'cloudService') {
      url = cloudService + url;
    }
    return axiosInstance({
      method: 'get',
      url,
      // timeout: 60000,
      responseType: "blob",
    });
  },
  post(url, data, responseType,gateway) {     //post请求
    if (!gateway) {
      gateway = 'identityService'
    }
    // if (gateway === 'vatService') {
    //   gateway = vatService
    // }
    if (url.indexOf('http') == -1) {
      url = eval(gateway) + url;
    }
    var obj = {
      method: 'post',
      url,
      data,
      // timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
      }
    }, params = {};
    if (responseType)
      params = Object.assign(obj, {responseType: 'blob'});//请求文件流
    else
      params = obj;
    return axiosInstance(params);
  },
  downZip(url, data, responseType) {     //post请求
    if (url.indexOf('http') == -1) url = fileService + url;
    var params = {
      method: 'post',
      url,
      data,
      responseType: 'blob',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
      }
    };
    return axiosInstance(params);
  },

  get(url, params,gateway) {        //get请求
    if (!gateway) {
      gateway = 'identityService'
    }
    if (url.indexOf('http') === -1) {
      url = eval(gateway) + url;
    }
    var obj = {
      method: 'get',
      url,
      // timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    };
    if (params) obj.params = params;
    return axiosInstance(obj);
  },

  delete(url, data,gateway) {        //delete请求
    if (!gateway) {
      gateway = 'identityService'
    }
    if (url.indexOf('http') == -1) {
      url = eval(gateway) + url;
    }
    var obj = {
      method: 'delete',
      url,
      data,
      // timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
    };
    // if (params) obj.params = params;
    return axiosInstance(obj);
  },

  put(url, data,gateway) {        //put请求
    if (!gateway) {
      gateway = 'identityService'
    }
    if (url.indexOf('http') == -1) {
      url = eval(gateway) + url;
    }
    return axiosInstance({
      method: 'put',
      url,
      data,
      // timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/public/ajax.js